export enum IPListsRouteName {
    Index = 'system.ips.index',
    Create = 'system.ips.create',
    Edit = 'system.ips.edit',
}

export default {
    path: 'ips',
    name: IPListsRouteName.Index,
    component: () => import('@/views/system/ip/Index.vue'),
    meta: {
        auth: true,
        label: 'IP Lists',
        icon: 'fal fa-map-marker-alt fa-fw',
        group: 'main',
        location: 'sidebar',
        permission: 'manage-ips',
    },
    children: [
        {
            path: 'create',
            name: IPListsRouteName.Create,
            component: () => import('@/views/system/ip/Index.vue'),
            meta: {
                auth: true,
                label: 'Add IP',
                icon: 'fal fa-folder-tree fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-ips',
            },
        },
        {
            path: ':ipId/edit',
            name: IPListsRouteName.Edit,
            component: () => import('@/views/system/ip/Index.vue'),
            meta: {
                auth: true,
                label: 'Edit IP',
                icon: 'fal fa-folder-tree fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-ips',
            },
        },
    ],
}
